import { r, createSender, createRemover, createUpdater, createReceiver, createFileSender, baseResource as baseSimpleResource } from '@/plugins/resource/resource'
import { queryPostfix, prefixAPI, urlConstructor } from '@/plugins/resource/api'
import { friendlyUrlGenerator } from '@/packages/vue-friendly'
import { baseResource } from '@aspectus/resource'
import { prefixLanguage } from '@/utils/urls'

const c = (...args) => args.join('')

// Models
const MODEL = 'medical-facilities'
const MODEL_ADMIN = '/admin'
const MODEL_NETWORK = 'network'
const MODEL_SERVICE = c(MODEL, '/service')
const MODEL_SERVICE_DOCTOR = c(MODEL_SERVICE, '/doctor')
const MODEL_SERVICE_GROUP = c(MODEL_SERVICE, '/group{/facility}')
const MODEL_DOCUMENTS = c(MODEL, '/documents')
const MODEL_CURRENCY = c(MODEL, '/currency')
const MODEL_BRANCH = c(MODEL, '/branches')
const MODEL_BRANCH_ACTION = c(MODEL, '/branch/action')
const MODEL_BRANCH_PHOTOS = c(MODEL_BRANCH, '/photos')
const MODEL_IMPORT_SERVICES = 'import_services'
const MODEL_COMMISSION_SETTING = c(MODEL, '/commission-setting')

// base path for the resources
const DETAIL_URL = '/detail/{id}/'
const UPDATE_URL  = '/update/{id}/'
const CREATE_URL = '/create/'

export const IMPORT_SERVICES_METHODS_LIST_URL = urlConstructor(MODEL_IMPORT_SERVICES+'/methods/list/', [])  

export const MEDICAL_FACILITY_URL = `/${MODEL}/`
export const MEDICAL_FACILITY_NETWORK_URL = `/${MODEL_NETWORK}/`
export const MEDICAL_FACILITY_CATALOG_URL = prefixLanguage(`/catalog/${MODEL}/`)
export const MEDICAL_FACILITY_DOCTOR_LIST_URL = c(MODEL, '/map/doctor-list/')
export const MEDICAL_FACILITY_MAP_LIST_URL = prefixAPI('/map/list/', MODEL)
export const MEDICAL_FACILITY_TABS_CLEAR_URL = `/${MODEL}/{label}/ajax/tab/`
export const MEDICAL_FACILITY_TABS_URL = `/${MODEL}/{label}/ajax/tab/{tab}/`

export const MEDICAL_FACILITY_FILTERS_URL = urlConstructor(`${MODEL}/catalog/filters/`, [])
export const MEDICAL_FACILITY_ATTRIBUTE_CONFIG_URL = prefixAPI('/catalog/attributes-config/filters/', MODEL)
export const MEDICAL_FACILITY_FILTERS_DOCTORS_URL = urlConstructor(`${MODEL}/{uuid}/filters/doctors/`, [])

export const MEDICAL_FACILITY_FILTERS_SERVICES_URL = urlConstructor(`${MODEL}/{uuid}/filters/services/`, [])
export const MEDICAL_FACILITY_FILTERS_SERVICE_URL = urlConstructor(`${MODEL}/{uuid}/filters/service/{serviceId}/`, [])
export const MEDICAL_FACILITY_FILTERS_SPECIALIZATION_URL = urlConstructor(`${MODEL}/{uuid}/filters/specialization/{spesializationId}/`, [])
export const MEDICAL_FACILITY_FILTERS_REVIEWS_URL = urlConstructor(`${MODEL}/{uuid}/filters/reviews/`, [])
export const MEDICAL_FACILITY_CATALOG_SPECIALIZATION_SERVICES_URL = `/${MODEL}/{facility}/spesializations/{spesialization}/`
export const MEDICAL_FACILITY_CATALOG_SPECIALIZATION_SERVICES_CATALOG_URL = `/${MODEL}/{uuid}/spesializations/{spesializationSlug}/`

export const MEDICAL_FACILITIES_TYPE_LIST_URL = urlConstructor(MODEL+'/type/list/', ['search'])
export const MEDICAL_FACILITIES_DIRECTIONS_TREATMENT_LIST_URL = urlConstructor(MODEL+'/directions-treatment/list/', [])
export const MEDICAL_FACILITIES_FORM_OWNERSHIP_LIST_URL = urlConstructor(MODEL+'/form-ownership/list/', [])
export const MEDICAL_FACILITIES_PUBLIC_LIST_URL = urlConstructor(MODEL+'/public/list/', ['search'])
export const MEDICAL_FACILITIES_BRANCHES_PUBLIC_LIST_URL = urlConstructor(MODEL+'/public/branches/list/', ['search', 'medical_facility'])
export const MEDICAL_FACILITIES_SEARCH_LIST_URL = urlConstructor(MODEL+'/search/', ['search'])

export const BRANCHES_BY_FACILITY_LIST_URL = urlConstructor(MODEL_BRANCH+'{/medical_id}/list/', [])

export const BRANCHES_FROM_DOCTOR_LIST_URL = urlConstructor(MODEL+'/from-doctor/list{/doctor_id}/', ['search', 'speciality'])


export const MEDICAL_FACILITIES_MAP_DETAIL_URL = c(MODEL, '/map', DETAIL_URL)

// commission-setting url
export const MEDICAL_FACILITIES_COMMISSION_DETAIL_URL = c(MODEL_COMMISSION_SETTING, '{/medical_id}/detail/')
export const MEDICAL_FACILITIES_COMMISSION_SAVE_URL = c(MODEL_COMMISSION_SETTING, '{/medical_id}/save/')
export const MEDICAL_FACILITIES_COMMISSION_SAVE_AND_APPLY_URL = c(MODEL_COMMISSION_SETTING, '{/medical_id}/save-and-apply/')

// services urls
export const MEDICAL_FACILITIES_SERVICE_LIST_URL = queryPostfix(MODEL_SERVICE+'{/facility}/list/', ['filters'])
export const MEDICAL_FACILITIES_SERVICE_ACTIVE_LIST_URL = prefixAPI(queryPostfix(MODEL_SERVICE+'{/facility}/active-list/', ['filters', 'search']))
export const MEDICAL_FACILITIES_SERVICE_DETAIL_URL = c(MODEL_SERVICE, '{/facility}', DETAIL_URL, )
export const MEDICAL_FACILITIES_SERVICE_UPDATE_URL = c(MODEL_SERVICE, '{/facility}', UPDATE_URL, )
export const MEDICAL_FACILITIES_SERVICE_CREATE_URL = c(MODEL_SERVICE, CREATE_URL, )
export const MEDICAL_FACILITIES_SERVICE_STATUSES_URL = c(MODEL_SERVICE, '/status/list/' )

export const MEDICAL_FACILITIES_SERVICE_CHANGE_STATUS_URL = c(MODEL_SERVICE, '/action{/facility}/change-status/')
export const MEDICAL_FACILITIES_SERVICE_SEND_FOR_MODERATION_URL = c(MODEL_SERVICE, '/action{/facility}/send-for-moderation/')

// currency urls
export const MEDICAL_FACILITIES_CURRENCY_AVAILABLE_LIST_URL = prefixAPI(c(MODEL_CURRENCY, '/available/list{/id}/'))
export const MEDICAL_FACILITIES_CURRENCY_CONVERSION_METHOD_LIST_URL = prefixAPI(c(MODEL_CURRENCY, '/conversion-method/list/'))

// services doctor url
export const MEDICAL_FACILITIES_SERVICE_DOCTORS_ADD_URL = c(MODEL_SERVICE_DOCTOR, '/add/')
export const MEDICAL_FACILITIES_SERVICE_DOCTORS_AVAILABLE_URL = c(MODEL_SERVICE_DOCTOR, '/available-list{/facility_service_id}/')
export const MEDICAL_FACILITIES_SERVICE_DOCTORS_CHANGE_STATUS_URL = c(MODEL_SERVICE_DOCTOR, '/change-status{/facility}/')
export const MEDICAL_FACILITIES_SERVICE_DOCTORS_DELETE_URL = c(MODEL_SERVICE_DOCTOR, '/delete{/id}/')
export const MEDICAL_FACILITIES_SERVICE_DOCTORS_LIST_URL = c(MODEL_SERVICE_DOCTOR, '/list{/facility_service_id}/')


// group urls
export const MEDICAL_FACILITIES_SERVICE_GROUP_CRETE_URL = c(MODEL_SERVICE_GROUP, '/create/')
export const MEDICAL_FACILITIES_SERVICE_GROUP_DELETE_URL = c(MODEL_SERVICE_GROUP, '/delete/')
export const MEDICAL_FACILITIES_SERVICE_GROUP_LIST_URL = c(MODEL_SERVICE_GROUP, '/list/')
export const MEDICAL_FACILITIES_SERVICE_GROUP_REORDER_URL = c(MODEL_SERVICE_GROUP, '/reorder/')
export const MEDICAL_FACILITIES_SERVICE_GROUP_UPDATE_URL = c(MODEL_SERVICE_GROUP, '/update{/id}/')
export const MEDICAL_FACILITIES_SERVICE_GROUP_CHANGE_URL = c(MODEL_SERVICE, '/action{/facility}/change-group/')

// docs urls
export const MEDICAL_FACILITIES_DOCUMENTS_ISSUING_AUTHORITY_LIST_URL = prefixAPI(c(MODEL_DOCUMENTS, '/issuing-authority/list/'))
export const MEDICAL_FACILITIES_DOCUMENTS_LICENSE_STATUS_LIST_URL = prefixAPI(c(MODEL_DOCUMENTS, '/license-status/list/'))
export const MEDICAL_FACILITIES_DOCUMENTS_CREATE_URL = c(MODEL_DOCUMENTS, '{/facility}/create/')
export const MEDICAL_FACILITIES_DOCUMENTS_DELETE_URL = c(MODEL_DOCUMENTS, '{/facility}/delete{/id}/')
export const MEDICAL_FACILITIES_DOCUMENTS_DETAIL_URL = c(MODEL_DOCUMENTS, '{/facility}/detail{/id}/')
export const MEDICAL_FACILITIES_DOCUMENTS_UPDATE_URL = c(MODEL_DOCUMENTS, '{/facility}/update{/id}/')
export const MEDICAL_FACILITIES_DOCUMENTS_LIST_URL = c(MODEL_DOCUMENTS, '{/facility}/list/')
export const MEDICAL_FACILITIES_DOCUMENTS_VALIDITY_PERIOD_URL = prefixAPI(c(MODEL_DOCUMENTS, '/validity-period/list/'))

// request moderation urls
const MEDICAL_FACILITY_PRE_MODERATION_CHECK_URL = '/check-pre-moderation/'
const MEDICAL_FACILITY_MODERATION_REQUEST_URL = '/create-moderation/'
const MEDICAL_FACILITY_MODERATION_LIST_URL = '/moderation/list/'

// admin urls
export const FACILITY_ADMIN_ACTION_BLOCK_URL = c(MODEL, MODEL_ADMIN, '/action/block/')
export const FACILITY_ADMIN_CHANGE_STATUS_URL = c(MODEL, MODEL_ADMIN, '/change-status/')
export const FACILITY_ADMIN_DETAIL_URL = c(MODEL, MODEL_ADMIN, '/detail{/id}/')
export const FACILITY_ADMIN_LIST_URL = c(MODEL, MODEL_ADMIN, '/list/')
export const FACILITY_ADMIN_FILTER_LIST_URL = c(MODEL, MODEL_ADMIN, '/filter-list/')
export const FACILITY_ADMIN_STATUS_LIST_URL = c(MODEL, MODEL_ADMIN, '/status-list/')

// branch photo urls
export const BRANCH_PHOTO_CREATE_URL = c(MODEL_BRANCH_PHOTOS, '/create/')
export const BRANCH_PHOTO_LIST_URL = queryPostfix(c(MODEL_BRANCH_PHOTOS, '/list/'), [])

// general resources
export const COORDINATOR_FACILITIES_LIST_URL = queryPostfix(MODEL + '/for-coordinators{/chain}/list/', ['filters'])

export const getFacility = r(DETAIL_URL, MODEL)
export const coordinatorListFacilities = r(COORDINATOR_FACILITIES_LIST_URL)
export const coordinatorListFiltersFacilities = r('/for-coordinators{/chain}/filter/list/', MODEL)
export const createFacility = r(CREATE_URL, MODEL, createSender)
export const updateFacility = r('/update/{id}/', MODEL, createUpdater)
export const updateFacilityCompany = r('/update-company/{id}/', MODEL, createUpdater)

export const facilitiesListForDoctorsResource = r(queryPostfix('/for-doctors/list/'), MODEL)

// services resources
export const facilityServicesListResource = r(MEDICAL_FACILITIES_SERVICE_LIST_URL)
export const facilityServicesFiltersListResource = r('{/facility}/filter/list/', MODEL_SERVICE)
export const facilityServicesDoctorsBySpecializationResource = r('/doctors-by-specialization/', MODEL_SERVICE, createSender) // ??

export const facilityServiceRetrieveResource = r(MEDICAL_FACILITIES_SERVICE_DETAIL_URL)
export const facilityServiceUpdateResource = r(MEDICAL_FACILITIES_SERVICE_UPDATE_URL, '', createUpdater)
export const facilityServiceCreateResource = r(MEDICAL_FACILITIES_SERVICE_CREATE_URL, '', createSender)
export const facilityServiceChangeStatusResource = r(MEDICAL_FACILITIES_SERVICE_CHANGE_STATUS_URL, '', createSender)
export const facilityServiceSendForModerationResource = r(MEDICAL_FACILITIES_SERVICE_SEND_FOR_MODERATION_URL, '', createSender)
export const facilityServiceStatusesListResource = r(MEDICAL_FACILITIES_SERVICE_STATUSES_URL)

// documents resources
export const facilityDocumentsCreteResource = r(MEDICAL_FACILITIES_DOCUMENTS_CREATE_URL,'', createSender)
export const facilityDocumentsListResource = r(MEDICAL_FACILITIES_DOCUMENTS_LIST_URL, '')
export const facilityDocumentsDetailResource = r(MEDICAL_FACILITIES_DOCUMENTS_DETAIL_URL,'')
export const facilityDocumentsDeleteResource = r(MEDICAL_FACILITIES_DOCUMENTS_DELETE_URL,'', createRemover)
export const facilityDocumentsUpdateResource = r(MEDICAL_FACILITIES_DOCUMENTS_UPDATE_URL,'', createUpdater)

// currency
export const facilityCurrencySettingsDetailResource = r('/settings/detail{/facility}/', MODEL_CURRENCY)
export const facilityCurrencySettingsUpdateResource = r('/settings/update{/facility}/', MODEL_CURRENCY, createUpdater)

// commission settign resource
export const facilityCommissionSettingDetailResource = createReceiver(prefixAPI(MEDICAL_FACILITIES_COMMISSION_DETAIL_URL))
export const facilityCommissionSettingSaveResource = createSender(prefixAPI(MEDICAL_FACILITIES_COMMISSION_SAVE_URL))
export const facilityCommissionSettingSaveAndApplyResource = createSender(prefixAPI(MEDICAL_FACILITIES_COMMISSION_SAVE_AND_APPLY_URL))

// admin resurces
export const facilityAdminActionBlockResource = r(FACILITY_ADMIN_ACTION_BLOCK_URL,'', createSender)
export const facilityAdminChangeStatusResource = r(FACILITY_ADMIN_CHANGE_STATUS_URL,'', createSender)
export const facilityAdminDetailResource = r(FACILITY_ADMIN_DETAIL_URL,'')
export const facilityAdminListResource = r(queryPostfix(FACILITY_ADMIN_LIST_URL, ['filters']),'')
export const facilityAdminFilterListResource = r(FACILITY_ADMIN_FILTER_LIST_URL,'')
export const facilityAdminStatusListResource = r(FACILITY_ADMIN_STATUS_LIST_URL,'')

// branches resources
// export const ownListBranchesResource = r(queryPostfix('/owner/list/', ['filters']), MODEL_BRANCH)
// export const listBranchesResource = r(queryPostfix('{/medical_id}/list/', ['filters']), MODEL_BRANCH)
// export const filtersListBranchesResource = r('/filter/list/', MODEL_BRANCH)
// export const createBranchResource = r(CREATE_URL, MODEL_BRANCH, createSender)
// export const getBranchResource = r(DETAIL_URL, MODEL_BRANCH,)
// export const updateBranchResource = r(DETAIL_URL, MODEL_BRANCH, createUpdater)
// export const filtersListServicesBranchesResource = r('/filter/list-by-branch{/branch_id}/', MODEL_SERVICE)
// export const listServicesBranchesResource = r(queryPostfix('/services/list{/branch_id}/{?service_ids}'), MODEL_BRANCH)
// export const retrieveServiceBranchesResource = r(queryPostfix('/services/retrieve{/branch_id}{/service_id}/'), MODEL_BRANCH)
// export const updateServiceBranchesResource = r(queryPostfix('/services/update/{branch_id}/'), MODEL_BRANCH, createUpdater)
// export const doctorsBranchServiceResource = r(queryPostfix('/services{/branch_service_id}/doctors/list/'), MODEL_BRANCH)
// export const facilityBranchAcceptResource = r('/accepted/', MODEL_BRANCH_ACTION, createSender)
// export const facilityBranchRejectResource = r('/rejected/', MODEL_BRANCH_ACTION, createSender)
// export const facilityBranchDiscontinuedResource = r('/stopped/', MODEL_BRANCH_ACTION, createSender)
// export const branchesListForDoctorsResource = r(queryPostfix('/for-doctors/list/', ['search']), MODEL_BRANCH)

// filter resources
export const medicalFacilityResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_CATALOG_URL, 'ajax'
], baseResource)
export const medicalFacilityMapListResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_MAP_LIST_URL, 'filters/'
], baseResource)
export const medicalFacilityNetworkCatalogResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_NETWORK_URL, 'ajax'
], baseResource)
export const medicalFacilityDoctorsResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_URL, 'ajax/doctors'
], baseResource)
// deprecated
// export const medicalFacilityServicesResource = friendlyUrlGenerator([
//   MEDICAL_FACILITY_URL, 'ajax/services'
// ], baseResource)
export const medicalFacilityReviewsResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_URL, 'ajax/reviews'
], baseResource)
export const medicalFacilitySpecializationServicesCatalogResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_CATALOG_SPECIALIZATION_SERVICES_CATALOG_URL, 'ajax'
], baseResource)
export const medicalFacilitySpecializationServicesResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_CATALOG_SPECIALIZATION_SERVICES_URL, 'ajax'
], baseResource)

export const medicalFacilityAttributeConfigResource = friendlyUrlGenerator([
  MEDICAL_FACILITY_ATTRIBUTE_CONFIG_URL, ''
], baseSimpleResource)

export const medicalFacilityFiltersResource = createReceiver(MEDICAL_FACILITY_FILTERS_URL)
// export const medicalFacilityTabsClearResource = createReceiver(MEDICAL_FACILITY_TABS_CLEAR_URL)
// export const medicalFacilityTabsResource = createReceiver(MEDICAL_FACILITY_TABS_URL)
export const medicalFacilityFiltersDoctorsResource = createReceiver(MEDICAL_FACILITY_FILTERS_DOCTORS_URL)
export const medicalFacilityFiltersServicesResource = createReceiver(MEDICAL_FACILITY_FILTERS_SERVICES_URL)
export const medicalFacilityFiltersServiceResource = createReceiver(MEDICAL_FACILITY_FILTERS_SERVICE_URL)
export const medicalFacilityFiltersSpecializationResource = createReceiver(MEDICAL_FACILITY_FILTERS_SPECIALIZATION_URL)
export const medicalFacilityFiltersReviewsResource = createReceiver(MEDICAL_FACILITY_FILTERS_REVIEWS_URL)

// service doctor resources
export const facilityServiceDoctorsAddResource = r(MEDICAL_FACILITIES_SERVICE_DOCTORS_ADD_URL, '', createSender)
export const facilityServiceDoctorsChangeStatusResource = r(MEDICAL_FACILITIES_SERVICE_DOCTORS_CHANGE_STATUS_URL, '', createSender)
export const facilityServiceDoctorsDeleteResource = r(MEDICAL_FACILITIES_SERVICE_DOCTORS_DELETE_URL, '', createRemover)
export const facilityServiceDoctorsListResource = r(MEDICAL_FACILITIES_SERVICE_DOCTORS_LIST_URL)

// service group resources
export const facilityServiceGroupCreteResource =  r(MEDICAL_FACILITIES_SERVICE_GROUP_CRETE_URL, '', createSender)
export const facilityServiceGroupDeleteResource =  r(MEDICAL_FACILITIES_SERVICE_GROUP_DELETE_URL, '', createSender)
export const facilityServiceGroupListResource =  r(MEDICAL_FACILITIES_SERVICE_GROUP_LIST_URL )
export const facilityServiceGroupReorderResource =  r(MEDICAL_FACILITIES_SERVICE_GROUP_REORDER_URL, '', createSender)
export const facilityServiceGroupUpdateResource =  r(MEDICAL_FACILITIES_SERVICE_GROUP_UPDATE_URL, '', createUpdater)
export const facilityServiceGroupChangeResource = r(MEDICAL_FACILITIES_SERVICE_GROUP_CHANGE_URL, '', createSender)

export const facilityCheckPreModerationResource = r(MEDICAL_FACILITY_PRE_MODERATION_CHECK_URL, MODEL, createSender)
export const facilityModerationRequestResource = r(MEDICAL_FACILITY_MODERATION_REQUEST_URL, MODEL, createSender)

export const importServicesCreateResource = r('/create/', MODEL_IMPORT_SERVICES, createSender)
export const importServicesPreImportResource = r('/pre-import/', MODEL_IMPORT_SERVICES, createSender)
export const importServicesCanceledResource = r('/canceled/', MODEL_IMPORT_SERVICES, createSender)
export const importServicesGetTemplateResource = r('/get-import-template/', MODEL_IMPORT_SERVICES)
export const importServicesListResource = r(queryPostfix('/list/{medical_facility_id}/', ['filters']), MODEL_IMPORT_SERVICES)

export const facilityMapDetailResource = r(MEDICAL_FACILITIES_MAP_DETAIL_URL)
export const facilityDoctorListResource = friendlyUrlGenerator([prefixAPI(MEDICAL_FACILITY_DOCTOR_LIST_URL), 'filters/'], baseResource)
